/**
 * Builds an inline-style object exposing `pixelValue` as a CSS custom
 * property, so a component can hand a measured pixel size down to its own
 * stylesheet (e.g. `height: var(--puzzle-panel-height, auto)`) without the
 * stylesheet ever hard-coding it.
 *
 * Returns an empty object when `pixelValue` isn't a number yet (nothing has
 * been measured), so the property is left unset entirely and the
 * stylesheet's own `var(--name, fallback)` takes over — never forcing a
 * premature `0px` before a real measurement exists.
 *
 * @param {String} cssVariableName - e.g. "--puzzle-panel-height"
 * @param {Number|null} pixelValue - measured size in pixels, or null/undefined
 * @return {Object} style object suitable for Vue's :style binding
 */
export function buildPixelCssVarStyle(cssVariableName, pixelValue) {
	return typeof pixelValue === "number"
		? { [cssVariableName]: `${pixelValue}px` }
		: {};
}
